import { useGetCompanyDefault } from "../../api/company";

export const useMetadataCompaniesDefault = (params: {
  currencyId: number | undefined;
  searchName?: string;
}) => {
  const { data = { data: [] }, isLoading } = useGetCompanyDefault({
    currencyId: params?.currencyId,
    name: params?.searchName,
  });

  return { dataCompaniesDefault: data?.data, isLoading };
};
